import {isSqlDate, convertDateForUi, isUiDate, isUiDateTime, convertDateForApi, convertDateTimeForApi} from '@/helpers'

export default class BaseModel {
  public fields: any = {}
  constructor(data: any, relation: any, fields: any) {
    if (data) {
      const t = Object.keys(fields)
      t.map((field: any) => {
        let d = data[field]
        // Date ?
        const isDate = isSqlDate(data[field])
        if (isDate) d = convertDateForUi(data[field])
        // Bind
        this.fields[field] = d
      })
    } else {
      this.fields = fields
    }
    if (relation) {
      this.fields[relation.key] = relation.value
    }
  }

  getFields() {
    return this.fields
  }

  setFields(data) {
    const obj = {}
    const t = Object.keys(data)
    t.map((field: any) => {
      let d = data[field]
      // Date
      const isDate = isUiDate(data[field])
      const isDateTime = isUiDateTime(data[field])
      if (isDate) d = convertDateForApi(data[field])
      if (isDateTime) d = convertDateTimeForApi(data[field])
      // Bind
      obj[field] = d
    })
    return obj
  }
}
